export class CruiseSailsError extends Error {
    constructor(message) {
        super(message);
        this.name = 'CruiseSailsError';
    }
}
